import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
};

export const spinnerSlice = createSlice({
    name: "spinner",
    initialState,
    reducers: {
        startSpinner: (state) => {
            state.loading = true;
        },
        endSpinner: (state) => {
            state.loading = false;
        },
    },
});

export const { startSpinner, endSpinner } = spinnerSlice.actions;

export default spinnerSlice.reducer;
